import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 206  -  跳转剧情
 */

export default class EventJumpStory extends EventBase {
  /**
   * 跳转剧情的构造函数
   */
  constructor() {
    super()
    this.Parameter = ['1', '1', '', '0', '0', '0', '0', '0', '0', '0', '0', '0']
  }

  // #region 事件内主要属性参数
  /**
   * 剧情ID
   */
  get MapId() {
    return parseInt(this.Parameter?.[0] ?? '')
  }
  set MapId(value) {
    this.Parameter![0] = value.toString()
  }

  /**
   * 是否淡出
   */
  get IsFadeOut() {
    return this.Parameter?.[1] == '1'
  }
  set IsFadeOut(value) {
    this.Parameter![1] = value ? '1' : '0'
  }

  /**
   * 描述信息
   */
  get Description() {
    return this.Parameter?.[2] || ''
  }
  set Description(value) {
    this.Parameter && (this.Parameter[2] = value.toString())
  }

  /**
   * 画面淡出时间（帧）
   */
  get FadeFrame() {
    return parseInt(this.Parameter?.[3] ?? '0', 10) || 0
  }
  set FadeFrame(value) {
    const next = Math.max(0, Math.round(Number(value) || 0))
    this.Parameter![3] = next.toString()
  }

  // #endregion

  /**
   * 事件ID
   */
  Code = EventID.JumpStory

  /**
   * 获得该事件在事件列表的描述信息
   */
  /// <returns>事件描述信息</returns>
}
